import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { INSIGHTS, INSIGHTS_META } from "@/constants/insights";
import { SITE } from "@/constants/site";
import { slug } from "@/constants/projects";

export default function InsightsPage() {
  useEffect(() => {
    document.title = INSIGHTS_META.title;
    const meta = document.querySelector("meta[name='description']");
    const prev = meta?.content;
    if (meta) meta.content = INSIGHTS_META.meta;
    return () => {
      if (meta && prev) meta.content = prev;
    };
  }, []);

  return (
    <main data-testid="insights-page" className="bg-cream font-sans text-slate-800 antialiased">
      <section className="grain bg-forest py-24">
        <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-12">
          <Link to="/" className="flex w-fit items-center gap-3">
            <img src="/vr-logo.jpeg" alt="VR Ahmedabad Realtors logo" width="48" height="48" className="h-12 w-12 rounded-sm object-cover ring-1 ring-gold/50" />
            <span className="font-serif text-lg text-white">VR Ahmedabad Realtors</span>
          </Link>
          <h1 className="mt-10 max-w-3xl font-serif text-4xl tracking-tighter text-white sm:text-5xl">
            Property Insights & Guides
          </h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/75">
            Practical Ahmedabad real estate knowledge from advisors who work the market daily — buyer guides, area
            comparisons and investment notes.
          </p>
        </div>
      </section>

      <section className="py-20 lg:py-24">
        <div className="mx-auto max-w-7xl px-6 lg:px-12">
          <div className="grid grid-cols-1 gap-10 md:grid-cols-2">
            {INSIGHTS.map((a) => (
              <Link
                key={a.slug}
                to={`/insights/${a.slug}`}
                data-testid={`insight-card-${slug(a.slug)}`}
                className="group flex flex-col rounded-lg border border-black/5 bg-white p-8 transition-colors duration-200 hover:border-gold"
              >
                <p className="text-xs text-slate-400">
                  {a.date} · {a.readTime} · By VR Ahmedabad Realtors Advisory Team
                </p>
                <h2 className="mt-4 font-serif text-xl tracking-tight text-slate-900 transition-colors duration-200 group-hover:text-forest sm:text-2xl">
                  {a.h1}
                </h2>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600">{a.excerpt}</p>
                <span className="mt-6 flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-forest">
                  Read the guide
                  <ArrowRight size={14} weight="bold" className="text-gold transition-transform duration-200 group-hover:translate-x-1" />
                </span>
              </Link>
            ))}
          </div>
          <p className="mt-14 text-center text-sm text-slate-500">
            Need advice on a specific property? Call{" "}
            <a href={`tel:${SITE.phoneRaw}`} className="font-semibold text-forest hover:underline">
              {SITE.phoneDisplay}
            </a>{" "}
            or <Link to="/contact" className="font-semibold text-forest hover:underline">contact us</Link>.
          </p>
        </div>
      </section>
    </main>
  );
}
